<template>
  <material-card
    :title="`${ $t('Dipswitch status') }`"
    color="dover-blue">
    <v-form>
      <v-container
        py-0>
        <v-layout
          wrap>
          <v-flex
            xs12
            md12>
            <v-data-table
              :headers="headers"
              :items="dipswitches"
              :no-data-text="`${ Maglink.NoDataMessage(false) }`"
              :no-results-text="`${ Maglink.NoDataMessage(true) }`"
              hide-actions>
              <template
                slot="headerCell"
                slot-scope="{ header }">
                <span
                  class="dover-light-blue-color"
                  v-text="header.text" />
              </template>
              <template
                slot="items"
                slot-scope="{ index, item }">
                <td>{{ index + 1 }}</td>
                <td>
                  <v-switch
                    v-model="item.enabled"
                    readonly
                    class="dover-input"/>
                </td>
                <td>{{ item.name }}</td>
                <td>{{ item.description }}</td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </material-card>
</template>

<script>
import { i18n } from '@/i18n'

export default {
  props: {
    title: {
      type: String,
      required: true
    }
  },
  data: () => ({
    headers: [
      { sortable: false, text: i18n.t('Position') },
      { sortable: false, text: i18n.t('Status') },
      { sortable: false, text: i18n.t('Name') }
    ],
    dipswitches: []
  }),
  mounted () {
    this.Maglink.GetSettings('Dipswitches')
      .then(response => (this.dipswitches = response.data))
      .catch(error => (this.snack('error', error.message)))
  }
}
</script>
